import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form,Tooltip, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { newSubProductCreation,resetSubProductCreatiion } from "./subproductAction";
import { newAdultRatesCreation,newChildRatesCreation,newInfantRatesCreation,newSeasonalRatesCreation ,newPromotionRatesCreation,getSingleProductRate,productratesApproved,productratesRejected} from "../rates/ratesAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi";
import { useNavigate,useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { getAllProduct } from "../product/productAction";
import { FaEye, FaArrowLeft,FaArrowAltCircleRight, FaTrash, FaPlus} from 'react-icons/fa';
// import { Tooltip } from 'react-tooltip';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
const ViewRates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { baseId } = useParams();
  const { pid1 } = useParams();
  const { name2 } = useParams();
  const { pid2 } = useParams();
  const { pname1 } = useParams();
  const { pname2 } = useParams();
  const SubProductRef = useRef(null);
  const [productid,setProductid]= useState('');
  const [subproductname,setSubproductname]= useState('');
  
  const [perShow,setPerShow] = useState(false);
  const [fixamtShow,setFixamtShow] = useState(false);

  const [percentage,setPercentage]= useState('');
  const [fixamt,setFixamt]= useState('');
  const [paxlimit,setPaxlimit]= useState('');
  const [paxlimitno,setPaxlimitNo]= useState('');
  const [remarks, setRemarks] = useState([]);

  const [status,setStatus]= useState('');
  const [sfromDate , setSFromDate ] = useState('');
  const [toDate2 , setToDate2 ] = useState('');
  const [discounttype , setDiscounttype ] = useState('');
  const [discounttype2 , setDiscounttype2 ] = useState('');
  const [discount2 , setDiscount2 ] = useState('');
  const [discount , setDiscount ] = useState('');
  const [seasonalremark , setSeasonalremark ] = useState('');
  const [promotionremark , setPromotionremark ] = useState('');
  const [offercode , setOffercode ] = useState('');
  const [toDate3 , setToDate3 ] = useState('');
  const [fromDate , setFromDate ] = useState('');
  const [toDate , setToDate ] = useState('');
  const [fromDate2 , setFromDate2 ] = useState('');
  const [fromAge2, setFromAge2] = useState('');
  const [fromAge, setFromAge] = useState('');
  const [toAge, setToAge] = useState('');
  const [toAge2, setToAge2] = useState('');
  const [errors2, setErrors2] = useState({});
  const [tabHandle, setTabHandle] = useState('adultrate');
  const [tabHandle2, setTabHandle2] = useState('rate');
  const [errors3, setErrors3] = useState({});
  const [fromAgeError, setFromAgeError] = useState('');
  const [toAgeError, setToAgeError] = useState('');

  const [fromDateError, setFromDateError] = useState('');
  const [fromDateError2, setFromDateError2] = useState('');
  const [toDateError, setToDateError] = useState('');
  const [toDateError2, setToDateError2] = useState('');
  const [paxlimitshow, setPaxlimitShow] = useState(false);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [fromAgeError2, setFromAgeError2] = useState('');
  const [toAgeError2, setToAgeError2] = useState('');

  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, watch,formState: { errors } } = useForm();
  const { products } = useSelector((state) => state.productList);
  const { baseid,apmessage ,rmessage} = useSelector((state) => state.productratesList);

  const ratesvehicle  = useSelector((state) => state.productratesList?.rates?.vehicle || {});
  const rateshour  = useSelector((state) => state.productratesList?.rates?.hour || {});
  const rates  = useSelector((state) => state.productratesList?.rates?.adult || {});
  console.log(rates)
  const rates2 = useSelector((state) => state.productratesList?.rates?.child || {});
  const rates3 = useSelector((state) => state.productratesList?.rates?.infant || {});
  const rates4 = useSelector((state) => state.productratesList?.rates?.supplement || {});
  const rates5 = useSelector((state) => state.productratesList?.rates?.promotion || {});
  const baseData = useSelector((state) => state.productratesList?.rates?.baseData || {});
//   const { SubProductId } = useSelector((state) => state.subproductList);
// console.log("SubProductId",SubProductId)
  const { supiscLoading, supcstatus, supcMessage, } = useSelector((state) => state.supplierList);
  const [sections, setSections] = useState([]);
  const [sections2, setSections2] = useState([]);
  const [sections3, setSections3] = useState([]);
  const [sections4, setSections4] = useState([]);
  const [adultrate, setAdultrate] = useState([]);
  const [hourrate, setHourrate] = useState([]);
  const [vehiclerate, setVehiclerate] = useState([]);
  const [extraAdultrate, setExtraAdultrate] = useState([]);
  const [childrate, setChildrate] = useState([]);
  const [infantrate, setInfantrate] = useState([]);
  const [seasonal, setSeasonal] = useState([]);
  const [promotion, setPromotion] = useState([]);
  console.log("promotion",promotion)
  console.log("seasonal",seasonal)
  console.log("adultrate",adultrate)
  console.log("childrate", childrate)
  console.log("infantrate", infantrate)


  
  const handleAddSection = () => {
    setSections(prevSections => [...prevSections, { childrate: Array(7).fill('') }]);
  };
  const handleAddSection2 = () => {
    setSections2(prevSections => [...prevSections, { infantrate: Array(7).fill('') }]);
  };


  const handleAddSection3 = () => {
    setSections3(prevSections => [...prevSections, { seasonal: Array(7).fill('') }]);
  };

  const handleAddSection4 = () => {
    setSections4(prevSections => [...prevSections, { promotion: Array(7).fill('') }]);
  };

  const handleRemoveSection = (index) => {
    setSections(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection2 = (index) => {
    setSections2(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection3 = (index) => {
    setSections3(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection4 = (index) => {
    setSections4(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleCopyToAll2 = (sectionIndex, index) => {
    const selectedValue = sections[sectionIndex].childrate[index];
  const updatedRates = sections[sectionIndex].childrate.map(() => selectedValue);

  const updatedSections = [...sections];
  updatedSections[sectionIndex].childrate = updatedRates;
  setSections(updatedSections);
  };


  const handleCopyToAll3 = (sectionIndex, index) => {
    const selectedValue = sections2[sectionIndex].infantrate[index];
  const updatedRates = sections2[sectionIndex].infantrate.map(() => selectedValue);

  const updatedSections = [...sections2];
  updatedSections[sectionIndex].infantrate = updatedRates;
  setSections2(updatedSections);
  };

  const handleChildRateChange = (sectionIndex, index, value) => {
    const updatedSections = [...sections];
    updatedSections[sectionIndex].childrate[index] = value;
    setSections(updatedSections);
    setChildrate(updatedSections)
  };


  const handleInfantRateChange = (sectionIndex, index, value) => {
    const updatedSections = [...sections2];
    updatedSections[sectionIndex].infantrate[index] = value;
    setSections2(updatedSections);
    setInfantrate(updatedSections)
  };
  const handleAdultRateChange = (index, value) => {
    const updatedAdultrate = [...adultrate];
    updatedAdultrate[index] = value;
    setAdultrate(updatedAdultrate);
  };
  const handleHourRateChange = (index, value) => {
    const updatedHourrate = [...hourrate];
    updatedHourrate[index] = value;
    setHourrate(updatedHourrate);
  };


  const handleVehicleRateChange = (index, value) => {
    const updatedVehiclerate = [...vehiclerate];
    updatedVehiclerate[index] = value;
    setVehiclerate(updatedVehiclerate);
  };

  const handleExtraAdultRateChange = (index, value) => {
    const updatedAdultrate = [...extraAdultrate];
    updatedAdultrate[index] = value;
    setExtraAdultrate(updatedAdultrate);
  };

  const renderCommissionFields = () => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    if (!Array.isArray(rates)) {
        return null; // Return null or any other fallback JSX if rates2 is not an array
      }
      return rates.map((section, sectionIndex) => (
        <div>
        <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
          disabled
          value={section?.from_date}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={section?.to_date}
          disabled={!fromDate}
          onChange={(e) => setToDate(e.target.value)}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
            <br />
            <br />
        {daysOfWeek.map((day, index) => {
          const rate = section[day] || '';
  
          return (
            <React.Fragment key={index}>
              {/* <label>{day}</label> */}
              <input
                id={`adultrate-${index}`}
                type="number"
                disabled
                value={rate}
                
                onChange={(e) => handleAdultRateChange(index, e.target.value)}
                placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
                style={{ width: '100px', marginLeft: '35px', borderRadius: '4px', fontSize: '15px',color:'black' }}
              />
            </React.Fragment>
          );
        })}
      </div>
      ));
  };



  const renderCommissionFieldsHourly = () => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    if (!Array.isArray(rateshour)) {
        return null; // Return null or any other fallback JSX if rates2 is not an array
      }
      return rateshour.map((section, sectionIndex) => (
        <div>
        <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
          disabled
          value={section?.from_date}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={section?.to_date}
          disabled={!fromDate}
          onChange={(e) => setToDate(e.target.value)}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
            <br />
            <br />
        {daysOfWeek.map((day, index) => {
          const rate = section[day] || '';
  
          return (
            <React.Fragment key={index}>
              {/* <label>{day}</label> */}
              <input
                id={`hourrate-${index}`}
                type="number"
                disabled
                value={rate}
                
                onChange={(e) => handleHourRateChange(index, e.target.value)}
                placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
                style={{ width: '100px', marginLeft: '35px', borderRadius: '4px', fontSize: '15px',color:'black' }}
              />
            </React.Fragment>
          );
        })}
      </div>
      ));
  };


  const renderCommissionFieldsVehicle = () => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    if (!Array.isArray(ratesvehicle)) {
        return null; // Return null or any other fallback JSX if rates2 is not an array
      }
      return ratesvehicle.map((section, sectionIndex) => (
        <div>
        <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
          disabled
          value={section?.from_date}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={section?.to_date}
          disabled={!fromDate}
          onChange={(e) => setToDate(e.target.value)}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
            <br />
            <br />
        {daysOfWeek.map((day, index) => {
          const rate = section[day] || '';
  
          return (
            <React.Fragment key={index}>
              {/* <label>{day}</label> */}
              <input
                id={`vehiclerate-${index}`}
                type="number"
                disabled
                value={rate}
                
                onChange={(e) => handleVehicleRateChange(index, e.target.value)}
                placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
                style={{ width: '100px', marginLeft: '35px', borderRadius: '4px', fontSize: '15px',color:'black' }}
              />
            </React.Fragment>
          );
        })}
      </div>
      ));
  };
  


  const renderCommissionFields4 = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll4 = () => {
      const firstValue = extraAdultrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setExtraAdultrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div>
        {daysOfWeek.map((day, index) => (
          <>
          {/* <label>{day}</label> */}
          <input
            key={index}
            id={`extraAdultrate-${index}`}
            type="number"
            disabled
            value={extraAdultrate[index] || ''}
            onChange={(e) => handleExtraAdultRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll4}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </>
        ))}
       
      </div>
    );
  };
  const renderCommissionFields2 = () => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    if (!Array.isArray(rates2)) {
        return null; // Return null or any other fallback JSX if rates2 is not an array
      }

    return rates2.map((section, sectionIndex) => (
      <div>
        <div style={{ display: 'flex',marginTop:'30px' ,marginLeft:'71px' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Age
          </Form.Label>
          <Form.Select
            style={{ width: '268px', marginLeft: '15px' }}
            required
            disabled
            value={section.from_age}
          >
                <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>

          </Form.Select>

          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Age
          </Form.Label>
          <Form.Select
            style={{ width: '268px', marginLeft: '15px' }}
            required
            disabled
            value={section.to_age}
          >
                <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>

          </Form.Select>
        </div>
        <br />
        <br />
        {daysOfWeek.map((day, index) => {
          const rate = section[day] || '';
  
          return (
            <React.Fragment key={index}>
              {/* <label>{day}</label> */}
              <input
                id={`adultrate-${index}`}
                type="number"
                disabled
                value={rate}
                
                onChange={(e) => handleAdultRateChange(index, e.target.value)}
                placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
                style={{ width: '100px', marginLeft: '35px', borderRadius: '4px', fontSize: '15px',color:'black' }}
              />
            </React.Fragment>
          );
        })}
      </div>
    ));
  };



  const renderCommissionFields6 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    if (!Array.isArray(rates5)) {
        return null; // Return null or any other fallback JSX if rates2 is not an array
      }

    
    
    
      return rates5.map((section, sectionIndex) => (
      <div key={sectionIndex}>
        <div style={{ display: 'flex',marginLeft:'71px' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            disabled
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={section.start_date}
           
          />
          {fromDateError2 && <p className="text-danger" style={{ fontSize: '10px' }}>{fromDateError2}</p>}
  
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={section.end_date}
           disabled
          />
          {toDateError2 && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError2}</p>}
        </div>
        <br />
        <div style={{display:'flex',marginLeft:'80px'}}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label>

        <Form.Select disabled required name="discounttype2" value={section.discount_type}   style={{ width: '231px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              &nbsp;
    <Form.Control disabled  style={{ width: '231px',height:'36px' }} type="text"  name="discount2" required="true" autoComplete='off' placeholder="Enter Discount" value={section.discount}  />&nbsp;
    <Form.Control disabled  style={{ width: '231px',height:'36px' }} type="text"  name="offercode" required="true" autoComplete='off' placeholder="Enter Offer Code" value={section.offer_code} />

&nbsp;
   
        </div>
        <br />
        <Row className="mb-3" style={{marginLeft:"0px"}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  
   <DefaultEditor disabled rows="5" style={{backgroundColor:'white'}}   name="promotionremark" value={section.remarks} 
    />

</Form.Group>


</Row>    
        <br />
        {/* Rest of the code */}
      </div>
      ));
  };




  const renderCommissionFields5 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    if (!Array.isArray(rates4)) {
        return null; // Return null or any other fallback JSX if rates2 is not an array
      }

    
    
     return rates4.map((section, sectionIndex) => (
      <div key={sectionIndex}>
        <div style={{ display: 'flex',marginLeft:'71px' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            disabled
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={section.start_date}
            // onChange={handleFromDateChange}
          />
          {fromDateError && <p className="text-danger" style={{ fontSize: '10px' }}>{fromDateError}</p>}
  
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={section.end_date}
            disabled
            // onChange={handleToDateChange}
            // disabled={!sections3[sectionIndex].fromDate2}
            // min={sections3[sectionIndex].fromDate2}
          />
          {toDateError && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError}</p>}
        </div>
        <br />
        <div style={{display:'flex',marginLeft:'45px'}}>
        <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Seasonal Rate</Form.Label>

        <Form.Select disabled required name="discounttype" value={section.discount_type}   style={{ width: '270px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              {/* &nbsp;        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label> */}

    <Form.Control disabled name="discount"  style={{ width: '270px',height:'36px', marginLeft: '73px'  }} type="text" value={section.discount}     required="true" autoComplete='off' placeholder="Enter Discount"  />

&nbsp;
    
        </div>
        <br />
     
        <Row className="mb-3" style={{marginLeft:'0px'}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  {/* <Form.Label>Description</Form.Label> */}
  
   <DefaultEditor disabled rows="5"  name="seasonalremark"  style={{backgroundColor:'white'}} value={section.remarks}   
    />

</Form.Group>


</Row>        <br />
       
      </div>
   ));
  };
  
  
  




  const renderCommissionFields3 = () => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    if (!Array.isArray(rates3)) {
        return null; // Return null or any other fallback JSX if rates2 is not an array
      }

    return rates3.map((section, sectionIndex) => (
      <div>
        <div style={{ display: 'flex',marginTop:'30px',marginLeft:'71px'  }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Age
          </Form.Label>
          <Form.Select
            style={{ width: '268px', marginLeft: '15px' }}
            required
            disabled
            value={section.from_age}
          >
                <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>

          </Form.Select>

          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Age
          </Form.Label>
          <Form.Select
            style={{ width: '268px', marginLeft: '15px' }}
            required
            disabled
            value={section.to_age}
          >
                <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>

          </Form.Select>
        </div>
        <br />
        <br />
        {daysOfWeek.map((day, index) => {
          const rate = section[day] || '';
  
          return (
            <React.Fragment key={index}>
              {/* <label>{day}</label> */}
              <input
                id={`adultrate-${index}`}
                type="number"
                disabled
                value={rate}
                
                // onChange={(e) => handleAdultRateChange(index, e.target.value)}
                placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
                style={{ width: '100px', marginLeft: '35px', borderRadius: '4px', fontSize: '15px',color:'black' }}
              />
            </React.Fragment>
          );
        })}
      </div>
    ));
  };

  

  const validateToDate = (toDate) => {
    if (!fromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    return true; // Return true if the validation passes
  };

  const validateToDate2 = (stoDate) => {
    if (!sfromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(sfromDate);
    const toDateObj = new Date(stoDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    return true; // Return true if the validation passes
  };

  const validateForm = () => {
    const newErrors = {};

    if (fromAge === '') {
      newErrors.fromAge = 'From Age is required';
    }

    if (toAge === '') {
      newErrors.toAge = 'To Age is required';
    } else if (parseInt(toAge) <= parseInt(fromAge)) {
      newErrors.toAge = 'To Age must be greater than From Age';
    }

    setErrors2(newErrors);
  };

  const validateForm2 = () => {
    const newErrors = {};

    if (fromAge2 === '') {
      newErrors.fromAge2 = 'From Age is required';
    }

    if (toAge2 === '') {
      newErrors.toAge2 = 'To Age is required';
    } else if (parseInt(toAge2) <= parseInt(fromAge2)) {
      newErrors.toAge2 = 'To Age must be greater than From Age';
    }

    setErrors3(newErrors);
  };


  

  const handleFromAgeChange2 = (e) => {
    setFromAge2(e.target.value);
    setToAge2('');
  };
  
const handlePaxlimit = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name == "paxlimit" && checked){
    setPaxlimit(1);
    setPaxlimitShow(true)
  }else {
    setPaxlimit(0)
    setPaxlimitShow(false);
  }
}
  const handleCommission = (e) =>{

    if(e == "Percentage"){
      setPerShow(true);
      setFixamtShow(false)
    }else if(e == "Fixamt"){
      setFixamtShow(true)
      setPerShow(false);
    }
    }
  
  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getSingleProductRate(baseId));
    
  }, [apmessage, rmessage]);
  const handleOnSubmit = (e) => {
    e.preventDefault();
    if(productid && subproductname && status){
        const newSubProductCreation1 = {
            productid,
            subproductname,
            paxlimit,
            paxlimitno,
            status,

        };
        dispatch(
            newSubProductCreation(newSubProductCreation1)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Sub Product Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
  
          // navigate('/subproductList');
         
            setTabHandle2('rate')
        
        setProductid('');
        setSubproductname('');
        setPaxlimitNo('');
        setStatus('');
        e.target.reset();
    }
 
  };


  const handleOnSubmit1 = (e) => {
    e.preventDefault();

        const newAdultRateCreation = {
            baseId,
            fromDate,
            toDate,
            adultrate,

        };
        dispatch(
            newAdultRatesCreation(newAdultRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Adult Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };


  
  const handleOnSubmit2 = (e) => {
    e.preventDefault();

        const newChildRateCreation = {
            baseid,
            fromDate,
            toDate,
            fromAge,
            toAge,
            childRates: childrate,

        };
        dispatch(
            newChildRatesCreation(newChildRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Child Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };

  const onProductApprove = (id, e) => {
    e.preventDefault();
    Swal.fire({
        title: 'Are you sure want to approve the rates?',
        showDenyButton: true,
        icon:'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(productratesApproved(id)).then(() => {
            dispatch(getSingleProductRate(id)); 
            Swal.fire('Rates Approved Successfully!', '', 'success');
          })
      }else if (result.isDenied) {
        Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
      }

      })


}


const onProductReject = (id, subproducts, e,index) => {
  
    Swal.fire({
        title: 'Are you sure want to reject the rates?',
        showDenyButton: true,
        icon:'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      }).then((result) => {
        if (result.isConfirmed) {
         
          setOpen(true);
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
      }
    });
  };


    
  const handleOnSubmit3 = (e) => {
    e.preventDefault();

        const newInfantRateCreation = {
            baseid,
            fromDate,
            toDate,
            fromAge2,
            toAge2,
            infantRates: infantrate,

        };
        dispatch(
            newInfantRatesCreation(newInfantRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Infant Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };

  const handleOnSubmit4 = (e) => {
    e.preventDefault();

        const newSeasonalRateCreation = {
            baseid,
           
            seasonalRates: seasonal,

        };
        dispatch(
          newSeasonalRatesCreation(newSeasonalRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Seasonal Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };


  const handleOnSubmit5 = (e) => {
    e.preventDefault();

        const newPromotionRateCreation = {
            baseid,
           
            promotionRates: promotion,

        };
        dispatch(
          newPromotionRatesCreation(newPromotionRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Promotion Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
           navigate('/subproductList');
 
 
  };
  const onBack = () => {

    if(name2){
      navigate('/viewratespage/' + pid1+ "/" +pname1 + "/" + pid2 + "/" + pname2 + "/" + "approval");

    }else{
      navigate('/viewratespage/' + pid1+ "/" +pname1 + "/" + pid2 + "/" + pname2);
    }
   
    //console.log('select role '+id);
     
 }



 const onRemarksChange = (e) => {
   setRemarks(e.target.value);

};
const handleOnSubmit11 = () => {

  const commissionUpdation2 = {
    baseId, remarks
    };

  dispatch(productratesRejected(commissionUpdation2));
  setOpen(false)
  Swal.fire({
    title: 'Rejected!',
    text: 'Remark Sent Successfully',
    icon: 'success',
    confirmButtonText: 'Okay'
  })

  

  
};


  const canSave = Boolean (productid) && Boolean(subproductname) && Boolean(status)
//console.log(curstatus);
//console.log('msg');
//console.log(curmessage);
  //console.log(passwordError.confirmPassword);
  
  return (
    <>
         <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>View Rates</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white',cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>
   
                        </Row>
                        <br />
                <Tabs
      // defaultActiveKey='basic'
      activeKey={tabHandle2}
      id="justify-tab-example"
      className="mb-3"
      justify
    >
     

           
    <Tab eventKey="rate" title="Rate Details">
      
    
    <center><span className="badge bg" style={{backgroundColor:'rgb(156 186 237)',color:'black'}}>{rateshour.length == 0  && ratesvehicle.length == 0 ? <>From Date: {rates[0]?.from_date} --- To Date: {rates[0]?.to_date}</>:rateshour.length !== 0 ? <>From Date: {rateshour[0]?.from_date} --- To Date: {rateshour[0]?.to_date}</>:<>From Date: {ratesvehicle[0]?.from_date} --- To Date: {ratesvehicle[0]?.to_date}</>}</span></center>

    {name2 && (
  <span>
    {baseData?.[0]?.status === "Approved" ? (
      <>
      <Button variant="outlined" color="success" style={{ width: '100px', float: 'right', color: '', fontSize: '10px' }} startIcon={<CheckCircleOutlineIcon />}>
        Approved
      </Button>&nbsp;&nbsp;</>
    ) : baseData?.[0]?.status === "Rejected" ? (
      <>
      <Button variant="outlined"  color="error" style={{ width: '100px', float: 'right', color: '', fontSize: '10px', marginLeft: '5px' }} startIcon={<CancelIcon />}>
        Rejected
      </Button>&nbsp;&nbsp;</>
    ) : (
      <React.Fragment>
        <Button variant="outlined" onClick={(e) => onProductReject(baseId, e)} color="error" style={{ width: '100px', float: 'right', color: '', fontSize: '10px', marginLeft: '5px' }} startIcon={<CancelIcon />}>
          Reject
        </Button>&nbsp;&nbsp;
        <Button variant="outlined" color="success" style={{ width: '100px', float: 'right', color: '', fontSize: '10px' }} onClick={(e) => onProductApprove(baseId, e)} startIcon={<CheckCircleOutlineIcon />}>
          Approve
        </Button>
      </React.Fragment>
    )}
  </span>
)}

      <hr />
      
    <Tabs
      defaultActiveKey='adultrate'
    //   activeKey={tabHandle}
      id="justify-tab-example"
      className="mb-3"
      justify
      
    >
          {rateshour.length == 0 && ratesvehicle.length == 0 ?
            <Tab eventKey="adultrate" title="Adult Rates">
    
{rates.length > 0 ? <><Form disabled className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}> {/* handleOnSubmit() */}
            <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
      

    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Adult Rates</h6>
      
      <hr style={{marginTop:'5px',color:'white'}} />
     

      {renderCommissionFields()}
    <br />
      {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

     <br />
     {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
     <br />

    </Card>
   

          </Form></>:<><h3 style={{textAlign:'center',color:'red'}}>No Data!!!</h3></>}
          <div>
    
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Reason For Rejection</DialogTitle>
        <DialogContent>
        
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label=""
            multiline="4"
            type="email"
            fullWidth
            onChange={(e) => onRemarksChange(e)}
            
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant='outlined' color='error'>Cancel</Button>
          <Button onClick={handleOnSubmit11} variant='outlined' color='success'>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
            
    </Tab>
    :""}



    {/* //hour */}
    {rateshour.length > 0 ?
    <Tab eventKey="adultrate" title="Hourly Rates">
    
    {rateshour.length > 0 ? <><Form disabled className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}> {/* handleOnSubmit() */}
                <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
          
    
        <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Hourly Rates</h6>
          
          <hr style={{marginTop:'5px',color:'white'}} />
         
    
          {renderCommissionFieldsHourly()}
        <br />
          {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}
    
         <br />
         {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
         <br />
    
        </Card>
       
    
              </Form></>:<><h3 style={{textAlign:'center',color:'red'}}>No Data!!!</h3></>}
              <div>
        
          <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle>Reason For Rejection</DialogTitle>
            <DialogContent>
            
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label=""
                multiline="4"
                type="email"
                fullWidth
                onChange={(e) => onRemarksChange(e)}
                
                variant="standard"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} variant='outlined' color='error'>Cancel</Button>
              <Button onClick={handleOnSubmit11} variant='outlined' color='success'>Save</Button>
            </DialogActions>
          </Dialog>
        </div>
                
        </Tab>
        :""}

{/* vehicle */}
{ratesvehicle.length > 0 ?
    <Tab eventKey="adultrate" title="Vehicle Rates">
    
    {ratesvehicle.length > 0 ? <><Form disabled className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}> {/* handleOnSubmit() */}
                <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
          
    
        <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Vehicle Rates</h6>
          
          <hr style={{marginTop:'5px',color:'white'}} />
         
    
          {renderCommissionFieldsVehicle()}
        <br />
          {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}
    
         <br />
         {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
         <br />
    
        </Card>
       
    
              </Form></>:<><h3 style={{textAlign:'center',color:'red'}}>No Data!!!</h3></>}
              <div>
        
          <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle>Reason For Rejection</DialogTitle>
            <DialogContent>
            
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label=""
                multiline="4"
                type="email"
                fullWidth
                onChange={(e) => onRemarksChange(e)}
                
                variant="standard"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} variant='outlined' color='error'>Cancel</Button>
              <Button onClick={handleOnSubmit11} variant='outlined' color='success'>Save</Button>
            </DialogActions>
          </Dialog>
        </div>
                
        </Tab>
        :""}

        {rateshour.length == 0 && ratesvehicle.length == 0 ?
    <Tab eventKey="childrate" title="Child Rates">
    
{rates2.length > 0 ? <><Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit2(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Child Rates</h6>
  

{/* <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection}><FaPlus/>&nbsp;Add </Button></div> */}

    <div >
     <hr style={{marginTop:'5px',color:'white'}} />
      {/* Render your section-specific fields here */}
      {renderCommissionFields2()}
      {/* <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection(index)}><FaTrash  /></Button> */}
    </div>

  <br />
  <hr style={{marginTop:'5px',color:'white'}} />

  

  <br />
  {/* <div><Button variant=""  type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

 <br />
 
 {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('infantrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
 <br />

</Card>
</Form></>:<><h3 style={{textAlign:'center',color:'red'}}>No Data!!!</h3></>}
    
</Tab>
:""}

{rateshour.length == 0 && ratesvehicle.length == 0 ?

<Tab eventKey="infantrate" title="Infant Rates">
    
{rates3.length > 0 ? <>  <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit3(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Infant Rates</h6>
{/* <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection2}><FaPlus/>&nbsp;Add </Button></div> */}



 


    <div >
            <hr style={{marginTop:'5px',color:'white'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields3()}
      {/* <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection2(index)}><FaTrash  /></Button> */}
    </div>

  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  

  <br />
  {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

 <br />
 
 {/* <div><Button variant="" type='submit' onClick={()=>setTabHandle('seasonalrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
 <br />
</Card>
</Form></>:<><h3 style={{textAlign:'center',color:'red'}}>No Data!!!</h3></>}
  



</Tab>
:""}

<Tab eventKey="seasonalrate" title="Seasonal Supplementary">
    {rates4.length > 0 ? <><Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit4(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Seasonal Supplementary</h6>
{/* <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection3}><FaPlus/>&nbsp;Add </Button></div> */}



 


    <div>
            <hr style={{marginTop:'5px',color:'white'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields5()}
      {/* <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection3(index)}><FaTrash  /></Button> */}
    </div>
 
  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  
  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}


 <br />
 
 {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('promotionalrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
 <br />
</Card>
</Form></>:<><h3 style={{textAlign:'center',color:'red'}}>No Data!!!</h3></>}

</Tab>

<Tab eventKey="promotionalrate" title="Promotion Discount">
   {rates5.length > 0 ? <><Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit5(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Promotion Discount</h6>
{/* <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection4}><FaPlus/>&nbsp;Add </Button></div> */}



 


    <div>
            <hr style={{marginTop:'5px',color:'white'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields6()}
      {/* <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection4(index)}><FaTrash  /></Button> */}
    </div>

  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  

  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

 <br />
 
 {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
 <br />
</Card>
</Form></>: <><h3 style={{textAlign:'center',color:'red'}}>No Data!!!</h3></>} 


</Tab>

           
   

    </Tabs>

    

</Tab>


    </Tabs>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewRates;